import {
  Box, Form, Text,
} from '@domain-group/suit-theme'

import TaskIcon from '@components/TaskIcon'

import useOrderItemTaskTypes from '@hooks/useOrderItemTaskTypes'

import type { useCreateOrEditOrderItemTaskModalPayload } from '../../hooks/useCreateOrEditOrderItemTaskModal'

interface TaskTypeProps {
  allowedTaskTypes: string[],
  hookPayload: useCreateOrEditOrderItemTaskModalPayload,
}

const TaskType = (props: TaskTypeProps) => {
  const { allowedTaskTypes, hookPayload } = props

  const { formPayload, newRecord, orderItemTaskType } = hookPayload

  const orderItemTaskTypesPayload = useOrderItemTaskTypes({
    filters: { allowed_task_types: allowedTaskTypes },
  })

  const { filteredOrderItemTaskTypes } = orderItemTaskTypesPayload

  const {
    entityState: {
      order_item_task_type_id,
    },
    errors,
    handlers,
  } = formPayload

  return (
    <>
      {newRecord && (
        <Form.Field label="* Task Type" errorMessage={errors.order_item_task_type_id}>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="number"
            name="order_item_task_type_id"
            value={order_item_task_type_id}
            {...handlers}
          >
            <option>Please Select...</option>
            {filteredOrderItemTaskTypes.map(taskType => (
              <option key={taskType.id} value={taskType.id}>{taskType.title}</option>
            ))}
          </select>
        </Form.Field>
      )}

      {!newRecord && (
        <Box alignItems="center">
          <TaskIcon height={54} taskTypeId={order_item_task_type_id} width={54} />

          <Box width="calc(100% - 60px)">
            <Form.Field label="Task Type" boxProps={{ marginLeft: 'large' }}>
              <Text>{orderItemTaskType.title || 'Custom'}</Text>
            </Form.Field>
          </Box>
        </Box>
      )}
    </>
  )
}

export default TaskType
